/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Image, Box } from '@mantine/core';

// Components
import { LanguageSelect } from '@components/atoms/LanguageSelect';
import { ResetPassword } from '@features/update-password/components/ResetPassword';

// Images
import EarthHandLogo from '@assets/images/earth-hand.svg';
import InukLogo from '@assets/images/inuk-logo.svg';

// Styles
import classes from './update-password.module.css';

// I18n
import { useTranslation } from 'react-i18next';

// Localstorage
import { useLocalStorage } from '@hooks/useLocalStorage';
import { JwtPayload, jwtDecode } from 'jwt-decode';

// Router
import { useLocation } from 'react-router';

// Utils
import { REGEX_TOKEN } from '@config/constants/regex';
import { isTokenExpired } from '@utils/auth';

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */
type CustomJwtPayload = Partial<JwtPayload> & {
	email: string;
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
const UpdatePassword = () => {
	/* ******************************** HOOKS ******************************* */

	const { i18n } = useTranslation();
	const [lng, setLng] = useLocalStorage('lng', 'en');
	const location = useLocation();
	const queryParams = new URLSearchParams(
		location.search
	);

	const token = queryParams.get('token')
		? queryParams.get('token')
		: '';

	const decodedPayload =
		token && REGEX_TOKEN.test(token)
			? jwtDecode<CustomJwtPayload>(token)
			: null;

	const email = decodedPayload
		? decodedPayload.email
		: '';

	const isValidToken = REGEX_TOKEN.test(
		token ? token : ''
	);

	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classes.layout}>
			<Box className={classes.header}>
				<Box className={classes.containerLogo}>
					<Image
						className={classes.logo}
						src={InukLogo}
						fit="contain"
					/>
				</Box>
				<Box className={classes.containerLanguage}>
					<LanguageSelect
						defaultValue={lng}
						onChange={(data: string) => {
							i18n.changeLanguage(data);
							setLng(data);
						}}
					/>
				</Box>
			</Box>
			<Box className={classes.content}>
				<Box className={classes.wrapper}>
					{/**Form */}
					<Box className={classes.containerLeft}>
						<ResetPassword
							token={token || ''}
							email={email}
							isValidToken={isValidToken}
							isTokenExpired={isTokenExpired(token)}
						/>
					</Box>
					{/**Image */}
					<Box className={classes.containerRight}>
						<Image src={EarthHandLogo} />
					</Box>
				</Box>
			</Box>
			<Box className={classes.footer}></Box>
		</Box>
	);
};

export default UpdatePassword;
